import React from 'react';
import './style.scss';
import SocialButtons from '../../../general/socialIcons';

const MarketNoAvailable = () => (
  <div className='market-page-no-available'>
    <h1>Sold Out!</h1>
    <h3>Follow us in socials to catch new NFT coming</h3>
    <SocialButtons />
  </div>
);

export default MarketNoAvailable;
